function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "background"), React.createElement("rect", {
  x: -1,
  y: -1,
  width: 409,
  height: 663,
  id: "canvas_background",
  fill: "#fff"
}), React.createElement("g", {
  id: "canvasGrid",
  display: "none"
}, React.createElement("rect", {
  id: "svg_3",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  strokeWidth: 0,
  fill: "url(#gridpattern)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("line", {
  stroke: "#666666",
  transform: "rotate(90 33.19995880126953,39.67657470703126) ",
  fill: "none",
  fillOpacity: "null",
  x1: 33.19996,
  y1: 11.27661,
  x2: 33.19996,
  y2: 68.07654,
  id: "svg_1",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  stroke: "#666666",
  transform: "rotate(90 33.830718994140625,34.291984558105476) ",
  fill: "none",
  fillOpacity: "null",
  x1: 33.86143,
  y1: 5.99976,
  x2: 33.80001,
  y2: 62.58421,
  id: "svg_19",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  stroke: "#666666",
  transform: "rotate(90 32.79996109008789,45.39967346191407) ",
  fill: "none",
  fillOpacity: "null",
  x1: 32.79996,
  y1: 17.39971,
  x2: 32.79996,
  y2: 73.39964,
  id: "svg_5",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  stroke: "#666666",
  transform: "rotate(90 33.19995880126953,51.214958190917976) ",
  fill: "none",
  fillOpacity: "null",
  x1: 33.19996,
  y1: 22.81499,
  x2: 33.19996,
  y2: 79.61492,
  id: "svg_133",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  transform: "rotate(90 22.9333324432373,58.373947143554695) ",
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 22.93333,
  y1: 41.57394,
  x2: 22.93333,
  y2: 75.17395,
  id: "svg_134",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 250.65858,
  y1: 630.4494,
  x2: 250.65858,
  y2: 655.4494,
  id: "svg_111",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 243.44097,
  y1: 630.4494,
  x2: 243.44097,
  y2: 655.4494,
  id: "svg_110",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 236.22336,
  y1: 630.4494,
  x2: 236.22336,
  y2: 655.4494,
  id: "svg_109",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 229.34166,
  y1: 630.4494,
  x2: 229.34166,
  y2: 655.4494,
  id: "svg_108",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 223.44397,
  y1: 630.4494,
  x2: 223.44397,
  y2: 655.4494,
  id: "svg_107",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 217.33364,
  y1: 630.4494,
  x2: 217.33364,
  y2: 655.4494,
  id: "svg_106",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 211.43596,
  y1: 630.4494,
  x2: 211.43596,
  y2: 655.4494,
  id: "svg_105",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 205.53827,
  y1: 630.4494,
  x2: 205.53827,
  y2: 655.4494,
  id: "svg_104",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 199.10005,
  y1: 630.4494,
  x2: 199.10005,
  y2: 655.4494,
  id: "svg_103",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 193.03335,
  y1: 630.4494,
  x2: 193.03335,
  y2: 655.4494,
  id: "svg_101",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 188.0041,
  y1: 630.4494,
  x2: 188.0041,
  y2: 655.4494,
  id: "svg_100",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 182.64696,
  y1: 630.4494,
  x2: 182.64696,
  y2: 655.4494,
  id: "svg_99",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 177.28982,
  y1: 630.4494,
  x2: 177.28982,
  y2: 655.4494,
  id: "svg_98",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 171.93267,
  y1: 630.4494,
  x2: 171.93267,
  y2: 655.4494,
  id: "svg_97",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 166.76487,
  y1: 630.4494,
  x2: 166.76487,
  y2: 655.4494,
  id: "svg_96",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 161.40773,
  y1: 630.4494,
  x2: 161.40773,
  y2: 655.4494,
  id: "svg_95",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 156.37848,
  y1: 630.4494,
  x2: 156.37848,
  y2: 655.4494,
  id: "svg_94",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 151.02133,
  y1: 630.4494,
  x2: 151.02133,
  y2: 655.4494,
  id: "svg_93",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 145.66419,
  y1: 630.4494,
  x2: 145.66419,
  y2: 655.4494,
  id: "svg_92",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 140.30705,
  y1: 630.4494,
  x2: 140.30705,
  y2: 655.4494,
  id: "svg_90",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.7,
  x: 0.75,
  y: -22.25,
  width: 0,
  height: 1,
  id: "svg_2"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_168",
  cy: 540.29308,
  cx: 176.40362,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_169",
  height: 4.65115,
  width: 10.85268,
  y: 520.74042,
  x: 170.91593,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_170",
  height: 4.65115,
  width: 10.85268,
  y: 555.14697,
  x: 170.91593,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_171",
  cy: 540.29308,
  cx: 176.40362,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_175",
  height: 10.68375,
  width: 4.2735,
  y: 534.44748,
  x: 190.79458,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_176",
  height: 10.68375,
  width: 4.2735,
  y: 534.87484,
  x: 157.8886,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_177",
  height: 4.65115,
  width: 10.85268,
  y: 520.74042,
  x: 222.63945,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_178",
  height: 4.65115,
  width: 10.85268,
  y: 555.14697,
  x: 222.63945,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_179",
  cy: 540.29308,
  cx: 228.12713,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_180",
  height: 10.68375,
  width: 4.2735,
  y: 534.44748,
  x: 242.51809,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_181",
  height: 10.68375,
  width: 4.2735,
  y: 534.87484,
  x: 209.61212,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_182",
  height: 4.65115,
  width: 10.85268,
  y: 78.12817,
  x: 363.67738,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_183",
  height: 4.65115,
  width: 10.85268,
  y: 112.53472,
  x: 363.67738,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_184",
  cy: 97.68083,
  cx: 369.16506,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_185",
  height: 10.68375,
  width: 4.2735,
  y: 91.83524,
  x: 383.55602,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_186",
  height: 10.68375,
  width: 4.2735,
  y: 92.26259,
  x: 350.65005,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_187",
  height: 4.65115,
  width: 10.85268,
  y: 127.30357,
  x: 364.29913,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_188",
  height: 4.65115,
  width: 10.85268,
  y: 161.71012,
  x: 364.29913,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_189",
  cy: 146.85623,
  cx: 369.78681,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_190",
  height: 10.68375,
  width: 4.2735,
  y: 141.01064,
  x: 384.17777,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_191",
  height: 10.68375,
  width: 4.2735,
  y: 141.43799,
  x: 351.2718,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_192",
  height: 4.65115,
  width: 10.85268,
  y: 570.69107,
  x: 223.0668,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_193",
  height: 4.65115,
  width: 10.85268,
  y: 605.09762,
  x: 223.0668,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_194",
  cy: 590.24373,
  cx: 228.55448,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_195",
  height: 10.68375,
  width: 4.2735,
  y: 584.39813,
  x: 242.94544,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_196",
  height: 10.68375,
  width: 4.2735,
  y: 584.82548,
  x: 210.03947,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_197",
  height: 4.65115,
  width: 10.85268,
  y: 571.11842,
  x: 171.34328,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_198",
  height: 4.65115,
  width: 10.85268,
  y: 605.52497,
  x: 171.34328,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_199",
  cy: 590.67107,
  cx: 176.83097,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_200",
  height: 10.68375,
  width: 4.2735,
  y: 584.82548,
  x: 191.22193,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_201",
  height: 10.68375,
  width: 4.2735,
  y: 585.25284,
  x: 158.31595,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_4",
  y2: 671,
  x2: 6,
  y1: 94,
  x1: 6,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_6",
  y2: 5,
  x2: 74,
  y1: 5,
  x1: 62,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_7",
  y2: 656,
  x2: 400,
  y1: 57,
  x1: 400,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  stroke: "#000",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_9",
  y2: 5,
  x2: 342,
  y1: 5,
  x1: 109,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_11",
  y2: 57.30159,
  x2: 399.80956,
  y1: 57.30159,
  x1: 340.80956,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_13",
  y2: 34.81007,
  x2: 341.15799,
  y1: 56.96193,
  x1: 341.15799,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_14",
  y2: 20,
  x2: 341.21185,
  y1: 4.6525,
  x1: 341.21185,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  fill: "none",
  stroke: "#444444",
  strokeWidth: 2,
  fillOpacity: "null",
  x1: 341.68492,
  y1: 20.12984,
  x2: 348.82777,
  y2: 32.46749,
  id: "svg_15",
  strokeLinejoin: "undefined",
  strokeLinecap: "undefined"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341,
  y1: 182.87008,
  x2: 398.83809,
  y2: 182.87008,
  id: "svg_18",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 62.10205,
  y1: 4,
  x2: 62.10205,
  y2: 59.53213,
  id: "svg_20",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 340.59681,
  y1: 182.16769,
  x2: 341,
  y2: 273,
  id: "svg_21",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341,
  y1: 288.99253,
  x2: 398.83809,
  y2: 288.99253,
  id: "svg_22",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341,
  y1: 395.11498,
  x2: 398.83809,
  y2: 395.11498,
  id: "svg_23",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 340.59681,
  y1: 288.29014,
  x2: 341,
  y2: 381,
  id: "svg_24",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 91,
  y1: 655.31906,
  x2: 398.83809,
  y2: 655.31906,
  id: "svg_25",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341,
  y1: 525,
  x2: 398.83809,
  y2: 525,
  id: "svg_26",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341,
  y1: 590.30612,
  x2: 398.83809,
  y2: 590.30612,
  id: "svg_27",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341,
  y1: 460.4211,
  x2: 398.83809,
  y2: 460.4211,
  id: "svg_28",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341.38989,
  y1: 394.9528,
  x2: 341.1562,
  y2: 446,
  id: "svg_29",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341.38989,
  y1: 459.79621,
  x2: 341.1562,
  y2: 507.84341,
  id: "svg_30",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341.38989,
  y1: 524.82564,
  x2: 341.1562,
  y2: 576,
  id: "svg_31",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 341.38989,
  y1: 590.4503,
  x2: 341.1562,
  y2: 640,
  id: "svg_32",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("rect", {
  id: "svg_33",
  height: 4.65115,
  width: 10.85268,
  y: 188.72544,
  x: 365.85487,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_34",
  height: 4.65115,
  width: 10.85268,
  y: 223.13198,
  x: 365.85487,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_35",
  cy: 208.27809,
  cx: 371.34255,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_36",
  height: 10.68375,
  width: 4.2735,
  y: 202.4325,
  x: 385.73352,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_37",
  height: 10.68375,
  width: 4.2735,
  y: 202.85985,
  x: 352.82754,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_38",
  height: 4.65115,
  width: 10.85268,
  y: 238.67608,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_39",
  height: 4.65115,
  width: 10.85268,
  y: 273.08263,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_40",
  cy: 258.22874,
  cx: 371.7699,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_41",
  height: 10.68375,
  width: 4.2735,
  y: 252.38315,
  x: 386.16087,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_42",
  height: 10.68375,
  width: 4.2735,
  y: 252.8105,
  x: 353.25489,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_43",
  height: 4.65115,
  width: 10.85268,
  y: 296.35257,
  x: 365.85487,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_44",
  height: 4.65115,
  width: 10.85268,
  y: 330.75912,
  x: 365.85487,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_45",
  cy: 315.90523,
  cx: 371.34255,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_46",
  height: 10.68375,
  width: 4.2735,
  y: 310.05964,
  x: 385.73352,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_47",
  height: 10.68375,
  width: 4.2735,
  y: 310.48699,
  x: 352.82754,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_48",
  height: 4.65115,
  width: 10.85268,
  y: 346.30322,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_49",
  height: 4.65115,
  width: 10.85268,
  y: 380.70977,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_50",
  cy: 365.85588,
  cx: 371.7699,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_51",
  height: 10.68375,
  width: 4.2735,
  y: 360.01028,
  x: 386.16087,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_52",
  height: 10.68375,
  width: 4.2735,
  y: 360.43764,
  x: 353.25489,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_53",
  height: 4.65115,
  width: 10.85268,
  y: 403.93035,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_54",
  height: 4.65115,
  width: 10.85268,
  y: 438.3369,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_55",
  cy: 423.483,
  cx: 371.7699,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_56",
  height: 10.68375,
  width: 4.2735,
  y: 417.63741,
  x: 386.16087,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_57",
  height: 10.68375,
  width: 4.2735,
  y: 418.06477,
  x: 353.25489,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_58",
  height: 4.65115,
  width: 10.85268,
  y: 469.1846,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_59",
  height: 4.65115,
  width: 10.85268,
  y: 503.59114,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_60",
  cy: 488.73725,
  cx: 371.7699,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_61",
  height: 10.68375,
  width: 4.2735,
  y: 482.89166,
  x: 386.16087,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_62",
  height: 10.68375,
  width: 4.2735,
  y: 483.31901,
  x: 353.25489,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_63",
  height: 4.65115,
  width: 10.85268,
  y: 534.43884,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_64",
  height: 4.65115,
  width: 10.85268,
  y: 568.84539,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_65",
  cy: 553.9915,
  cx: 371.7699,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_66",
  height: 10.68375,
  width: 4.2735,
  y: 548.14591,
  x: 386.16087,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_67",
  height: 10.68375,
  width: 4.2735,
  y: 548.57326,
  x: 353.25489,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_68",
  height: 4.65115,
  width: 10.85268,
  y: 601.38801,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_69",
  height: 4.65115,
  width: 10.85268,
  y: 635.79456,
  x: 366.28222,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_70",
  cy: 620.94066,
  cx: 371.7699,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_71",
  height: 10.68375,
  width: 4.2735,
  y: 615.09507,
  x: 386.16087,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_72",
  height: 10.68375,
  width: 4.2735,
  y: 615.52242,
  x: 353.25489,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: 2,
  x1: 340.36439,
  y1: 289.09055,
  x2: 350.20721,
  y2: 277.50547,
  id: "svg_75",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  stroke: "#000000"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: 2,
  x1: 341.06369,
  y1: 395.66332,
  x2: 350.90651,
  y2: 384.07824,
  id: "svg_76",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  stroke: "#000000"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: 2,
  x1: 341.06369,
  y1: 461.139,
  x2: 350.90651,
  y2: 449.55393,
  id: "svg_77",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  stroke: "#000000"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: 2,
  x1: 341.06369,
  y1: 524.82899,
  x2: 350.90651,
  y2: 513.24391,
  id: "svg_78",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  stroke: "#000000"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: 2,
  x1: 341.06369,
  y1: 590.30467,
  x2: 350.90651,
  y2: 578.7196,
  id: "svg_79",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  stroke: "#000000"
}), React.createElement("line", {
  fill: "none",
  strokeWidth: 2,
  x1: 341.06369,
  y1: 655.33964,
  x2: 350.90651,
  y2: 643.75456,
  id: "svg_80",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  stroke: "#000000"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 142.94515,
  y1: 4,
  x2: 142.94515,
  y2: 29,
  id: "svg_81",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  stroke: "#000",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_82",
  y2: 29.19465,
  x2: 252,
  y1: 29.19465,
  x1: 144.14146,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_83",
  y2: 58.57135,
  x2: 61,
  y1: 58.57135,
  x1: 34,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  stroke: "#000",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_85",
  y2: 631.23634,
  x2: 251.56856,
  y1: 631.23634,
  x1: 135,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 2,
  fill: "none"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 134.9499,
  y1: 630.4494,
  x2: 134.9499,
  y2: 655.4494,
  id: "svg_86",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 6,
  y1: 34,
  x2: 6,
  y2: 71,
  id: "svg_87",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 34.14287,
  y1: 34,
  x2: 34.14287,
  y2: 59,
  id: "svg_88",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 38,
  y1: 605.78577,
  x2: 38,
  y2: 661.3179,
  id: "svg_89",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  transform: "rotate(90 21.600000381469616,606.4000244140626) ",
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 21.6,
  y1: 589.6,
  x2: 21.6,
  y2: 623.20001,
  id: "svg_102",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  transform: "rotate(90 21.600000381469616,615.2000122070314) ",
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 21.6,
  y1: 598.4,
  x2: 21.6,
  y2: 632,
  id: "svg_112",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  transform: "rotate(90 21.600000381469616,624.0000000000001) ",
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 21.6,
  y1: 607.2,
  x2: 21.6,
  y2: 640.8,
  id: "svg_113",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  transform: "rotate(90 21.600000381469616,632.7999877929689) ",
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 21.6,
  y1: 616,
  x2: 21.6,
  y2: 649.6,
  id: "svg_114",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  transform: "rotate(90 21.600000381469616,640.0000000000001) ",
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 21.6,
  y1: 623.19999,
  x2: 21.6,
  y2: 656.8,
  id: "svg_115",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  transform: "rotate(90 21.600000381469616,647.2000122070314) ",
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 21.6,
  y1: 630.39999,
  x2: 21.6,
  y2: 664,
  id: "svg_127",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  transform: "rotate(90 21.600000381469616,654.4000244140626) ",
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 21.6,
  y1: 637.59999,
  x2: 21.6,
  y2: 671.2,
  id: "svg_128",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  transform: "rotate(90 21.600000381469616,659.4420166015626) ",
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 21.6,
  y1: 642.64201,
  x2: 21.6,
  y2: 676.24202,
  id: "svg_131",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_74",
  height: 45.68375,
  width: 23.27351,
  y: 437.96185,
  x: 40.39469,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_84",
  height: 10.68375,
  width: 4.2735,
  y: 445.8269,
  x: 30.5092,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_91",
  height: 10.68375,
  width: 4.2735,
  y: 466.90794,
  x: 30.5092,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_129",
  height: 10.68375,
  width: 4.2735,
  y: 466.90794,
  x: 67.80642,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_130",
  height: 10.68375,
  width: 4.2735,
  y: 446.36744,
  x: 67.80642,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_132",
  height: 4.65115,
  width: 10.85268,
  y: 490.07073,
  x: 46.23931,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_135",
  height: 4.65115,
  width: 10.85268,
  y: 427.36816,
  x: 46.23931,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_136",
  height: 45.68375,
  width: 23.27351,
  y: 354.71878,
  x: 40.39469,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_137",
  height: 10.68375,
  width: 4.2735,
  y: 362.58384,
  x: 30.5092,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_138",
  height: 10.68375,
  width: 4.2735,
  y: 383.66487,
  x: 30.5092,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_139",
  height: 10.68375,
  width: 4.2735,
  y: 383.66487,
  x: 67.80642,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_140",
  height: 10.68375,
  width: 4.2735,
  y: 363.12438,
  x: 67.80642,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_141",
  height: 4.65115,
  width: 10.85268,
  y: 406.82767,
  x: 46.23931,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_142",
  height: 4.65115,
  width: 10.85268,
  y: 344.1251,
  x: 46.23931,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_143",
  height: 45.68375,
  width: 23.27351,
  y: 269.31356,
  x: 40.39469,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_144",
  height: 10.68375,
  width: 4.2735,
  y: 277.17861,
  x: 30.5092,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_145",
  height: 10.68375,
  width: 4.2735,
  y: 298.25965,
  x: 30.5092,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_146",
  height: 10.68375,
  width: 4.2735,
  y: 298.25965,
  x: 67.80642,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_147",
  height: 10.68375,
  width: 4.2735,
  y: 277.71915,
  x: 67.80642,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_148",
  height: 4.65115,
  width: 10.85268,
  y: 321.42244,
  x: 46.23931,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_149",
  height: 4.65115,
  width: 10.85268,
  y: 258.71988,
  x: 46.23931,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_150",
  height: 45.68375,
  width: 23.27351,
  y: 184.98942,
  x: 40.39469,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_151",
  height: 10.68375,
  width: 4.2735,
  y: 192.85447,
  x: 30.5092,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_152",
  height: 10.68375,
  width: 4.2735,
  y: 213.93551,
  x: 30.5092,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_153",
  height: 10.68375,
  width: 4.2735,
  y: 213.93551,
  x: 67.80642,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_154",
  height: 10.68375,
  width: 4.2735,
  y: 193.39501,
  x: 67.80642,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_155",
  height: 4.65115,
  width: 10.85268,
  y: 237.0983,
  x: 46.23931,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_156",
  height: 4.65115,
  width: 10.85268,
  y: 174.39573,
  x: 46.23931,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_157",
  height: 4.65115,
  width: 10.85268,
  y: 520.74042,
  x: 273.54912,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_158",
  height: 4.65115,
  width: 10.85268,
  y: 555.14697,
  x: 273.54912,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_159",
  cy: 540.29308,
  cx: 279.03681,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_160",
  height: 10.68375,
  width: 4.2735,
  y: 534.44748,
  x: 293.42777,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_161",
  height: 10.68375,
  width: 4.2735,
  y: 534.87484,
  x: 260.52179,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_162",
  height: 4.65115,
  width: 10.85268,
  y: 570.69107,
  x: 273.97647,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_163",
  height: 4.65115,
  width: 10.85268,
  y: 605.09762,
  x: 273.97647,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_164",
  cy: 590.24373,
  cx: 279.46416,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_165",
  height: 10.68375,
  width: 4.2735,
  y: 584.39813,
  x: 293.85512,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_166",
  height: 10.68375,
  width: 4.2735,
  y: 584.82548,
  x: 260.94914,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 250.88283,
  y1: 3.80872,
  x2: 250.88283,
  y2: 28.80872,
  id: "svg_217",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 243.66522,
  y1: 3.80872,
  x2: 243.66522,
  y2: 28.80872,
  id: "svg_218",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 236.78351,
  y1: 3.80872,
  x2: 236.78351,
  y2: 28.80872,
  id: "svg_219",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 230.88583,
  y1: 3.80872,
  x2: 230.88583,
  y2: 28.80872,
  id: "svg_220",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 224.7755,
  y1: 3.80872,
  x2: 224.7755,
  y2: 28.80872,
  id: "svg_221",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 218.87781,
  y1: 3.80872,
  x2: 218.87781,
  y2: 28.80872,
  id: "svg_222",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 212.98013,
  y1: 3.80872,
  x2: 212.98013,
  y2: 28.80872,
  id: "svg_223",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 206.54191,
  y1: 3.80872,
  x2: 206.54191,
  y2: 28.80872,
  id: "svg_224",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 200.47521,
  y1: 3.80872,
  x2: 200.47521,
  y2: 28.80872,
  id: "svg_225",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 195.44596,
  y1: 3.80872,
  x2: 195.44596,
  y2: 28.80872,
  id: "svg_226",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 190.08882,
  y1: 3.80872,
  x2: 190.08882,
  y2: 28.80872,
  id: "svg_227",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 184.73168,
  y1: 3.80872,
  x2: 184.73168,
  y2: 28.80872,
  id: "svg_228",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 179.37453,
  y1: 3.80872,
  x2: 179.37453,
  y2: 28.80872,
  id: "svg_229",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 174.20673,
  y1: 3.80872,
  x2: 174.20673,
  y2: 28.80872,
  id: "svg_230",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 168.84959,
  y1: 3.80872,
  x2: 168.84959,
  y2: 28.80872,
  id: "svg_231",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 163.82034,
  y1: 3.80872,
  x2: 163.82034,
  y2: 28.80872,
  id: "svg_232",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 158.46319,
  y1: 3.80872,
  x2: 158.46319,
  y2: 28.80872,
  id: "svg_233",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 153.10605,
  y1: 3.80872,
  x2: 153.10605,
  y2: 28.80872,
  id: "svg_234",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#666666",
  fillOpacity: "null",
  x1: 147.74891,
  y1: 3.80872,
  x2: 147.74891,
  y2: 28.80872,
  id: "svg_235",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("g", {
  stroke: "null",
  id: "svg_215"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p1a",
  height: 10.90922,
  width: 151.81993,
  y: 67.31505,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p1b",
  height: 10.90922,
  width: 151.81993,
  y: 78.22427,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_238"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p2a",
  height: 10.90922,
  width: 183.99401,
  y: 108.32537,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p2b",
  height: 10.90922,
  width: 183.99401,
  y: 119.23458,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_241"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p3a",
  height: 10.90922,
  width: 183.99401,
  y: 150.20526,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p3b",
  height: 10.90922,
  width: 183.99401,
  y: 161.11447,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_244"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p4a",
  height: 10.90922,
  width: 183.99401,
  y: 192.25206,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p4b",
  height: 10.90922,
  width: 183.99401,
  y: 203.16128,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_247"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p5a",
  height: 10.90922,
  width: 183.99401,
  y: 235.73056,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p5b",
  height: 10.90922,
  width: 183.99401,
  y: 246.63978,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_250"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p6a",
  height: 10.90922,
  width: 183.99401,
  y: 281.67724,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p6b",
  height: 10.90922,
  width: 183.99401,
  y: 292.58645,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_253"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p7a",
  height: 10.90922,
  width: 183.99401,
  y: 326.47328,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p7b",
  height: 10.90922,
  width: 183.99401,
  y: 337.3825,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_256"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p8a",
  height: 10.90922,
  width: 183.99401,
  y: 373.85165,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p8b",
  height: 10.90922,
  width: 183.99401,
  y: 384.76087,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_259"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p9a",
  height: 10.90922,
  width: 183.99401,
  y: 419.79833,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p9b",
  height: 10.90922,
  width: 183.99401,
  y: 430.70754,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("g", {
  stroke: "null",
  id: "svg_262"
}, React.createElement("rect", {
  stroke: "#000",
  id: "p10a",
  height: 10.90922,
  width: 183.99401,
  y: 463.89172,
  x: 107.58979,
  fill: "#ffffff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "p10b",
  height: 10.90922,
  width: 183.99401,
  y: 474.80094,
  x: 107.58979,
  fill: "#ffffff"
})), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_263",
  cy: 540.29308,
  cx: 127.7077,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_264",
  height: 4.65115,
  width: 10.85268,
  y: 520.74042,
  x: 122.22001,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_265",
  height: 4.65115,
  width: 10.85268,
  y: 555.14697,
  x: 122.22001,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_266",
  cy: 540.29308,
  cx: 127.7077,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_267",
  height: 10.68375,
  width: 4.2735,
  y: 534.44748,
  x: 142.09866,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_268",
  height: 10.68375,
  width: 4.2735,
  y: 534.87484,
  x: 109.19269,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_269",
  height: 4.65115,
  width: 10.85268,
  y: 571.11842,
  x: 122.64736,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("rect", {
  id: "svg_270",
  height: 4.65115,
  width: 10.85268,
  y: 605.52497,
  x: 122.64736,
  strokeWidth: 0.7,
  stroke: "#000",
  fill: "#fff"
}), React.createElement("ellipse", {
  stroke: "#000",
  ry: 12,
  rx: 11.5,
  id: "svg_271",
  cy: 590.67107,
  cx: 128.13505,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_272",
  height: 10.68375,
  width: 4.2735,
  y: 584.82548,
  x: 142.52601,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("rect", {
  stroke: "#000",
  id: "svg_273",
  height: 10.68375,
  width: 4.2735,
  y: 585.25284,
  x: 109.62004,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 0.7,
  fill: "#fff"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 91.56527,
  y1: 656.17398,
  x2: 91.58962,
  y2: 665,
  id: "svg_274",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("path", {
  stroke: "#444444",
  transform: "rotate(90 65.60602569580068,645.3320312500001) ",
  id: "svg_275",
  d: "m64.87137,649.3908l2.5624,-2.50689l-4.95427,0l-4.95426,0l0,-1.55188l0,-1.55188l4.89742,0c2.69359,0 4.89743,-0.07866 4.89743,-0.17479c0,-0.09614 -1.07231,-1.22424 -2.3829,-2.50689l-2.38291,-2.3321l2.20253,0l2.20253,0l3.36376,3.28598l3.36375,3.28597l-3.37021,3.27969l-3.3702,3.27968l-2.31873,0l-2.31874,0l2.5624,-2.50689l0,0z",
  fillOpacity: "null",
  fill: "none"
}), React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  fontFamily: "Helvetica, Arial, sans-serif",
  fontSize: 12,
  id: "svg_276",
  y: 629.99489,
  x: 49.45961,
  fillOpacity: "null",
  strokeWidth: 0,
  stroke: "#444444",
  fill: "#000000"
}, "Anexo"), React.createElement("path", {
  stroke: "#444444",
  transform: "rotate(-90 91.86868286132814,13.00898933410644) ",
  id: "svg_277",
  d: "m91.13401,17.06776l2.5624,-2.50689l-4.95427,0l-4.95426,0l0,-1.55188l0,-1.55188l4.89742,0c2.69358,0 4.89742,-0.07866 4.89742,-0.1748c0,-0.09613 -1.0723,-1.22423 -2.38289,-2.50688l-2.38291,-2.3321l2.20253,0l2.20253,0l3.36376,3.28598l3.36375,3.28597l-3.37021,3.27968l-3.3702,3.27969l-2.31874,0l-2.31873,0l2.5624,-2.50689l0,0z",
  fillOpacity: "null",
  fill: "none"
}), React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  fontFamily: "Helvetica, Arial, sans-serif",
  fontSize: 12,
  id: "svg_278",
  y: 34.03542,
  x: 68.65153,
  fillOpacity: "null",
  strokeWidth: 0,
  stroke: "#444444",
  fill: "#000000"
}, "Cole\xE7\xF5es"), React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  fontFamily: "Helvetica, Arial, sans-serif",
  fontSize: 12,
  id: "svg_279",
  y: 46.15663,
  x: 68.65153,
  fillOpacity: "null",
  strokeWidth: 0,
  stroke: "#444444",
  fill: "#000000"
}, "Especiais"), React.createElement("g", {
  id: "svg_73"
}, React.createElement("path", {
  d: "m-4,70l24,0l0,24l-24,0l0,-24z",
  fill: "none",
  id: "svg_8"
}), React.createElement("circle", {
  cx: 8,
  cy: 74,
  r: 2,
  id: "svg_12"
}), React.createElement("path", {
  d: "m15,82l0,-2c-1.54,0.02 -3.09,-0.75 -4.07,-1.83l-1.29,-1.43c-0.17,-0.19 -0.38,-0.34 -0.61,-0.45c-0.01,0 -0.01,-0.01 -0.02,-0.01l-0.01,0c-0.35,-0.2 -0.75,-0.3 -1.19,-0.26c-1.05,0.09 -1.81,1.02 -1.81,2.07l0,5.91c0,1.1 0.9,2 2,2l5,0l0,5l2,0l0,-5.5c0,-1.1 -0.9,-2 -2,-2l-3,0l0,-3.45c1.29,1.07 3.25,1.94 5,1.95zm-6.17,5c-0.41,1.16 -1.52,2 -2.83,2c-1.66,0 -3,-1.34 -3,-3c0,-1.31 0.84,-2.41 2,-2.83l0,-2.07c-2.28,0.46 -4,2.48 -4,4.9c0,2.76 2.24,5 5,5c2.42,0 4.44,-1.72 4.9,-4l-2.07,0z",
  id: "svg_17"
})));

var SvgBase = function SvgBase(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "90vw",
    height: "80vh",
    viewBox: "0 0 410 665",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/base.28ace455.svg";
export { ForwardRef as ReactComponent };